module.exports = __webpack_public_path__ + "img/about_info.9a777776.png";